module.exports = __webpack_public_path__ + "static/media/colicoli29.fe023348.webp";